export default __webpack_public_path__ + "static/media/remos-signal.5e204dfa.png";